import type { ButtonTemplateProps } from './index';

export default function ButtonTemplate({ classes, label, disabled, backgroundColor, onClick }: ButtonTemplateProps) @{
  <button
    type="button"
    class={classes}
    disabled={disabled}
    style:background-color={backgroundColor}
    onClick={onClick}
    data-dls-component="button"
  >
    {label}
  </button>
}
